export const formatPhone = (phone) => {

    if (phone?.length < 11) {
        return phone;
    }
    const phoneNumber = phone.replace(/[^\d]/g, '');

    return `${phoneNumber.slice(0, 2)} ${phoneNumber.slice(2, 7)} ${phoneNumber.slice(7, phoneNumber?.length)} `;
}

export const removeMaskPhone = (phone) => {
  if (phone) {
    return phone.replaceAll(/\D/g, "");
  }
  return "";
}


export const testPhoneDDD = (phone) => {
  const phoneWithoutMask =  removeMaskPhone(phone)

  const phoneDDD = phoneWithoutMask.split('').splice(2,2).join('')

  const allDDDBrazil = [
    // CENTRO-OESTE
    '61', // DF
    '62', // GO
    '64', // GO
    '65', // MT
    '66', // MT
    '67', // MS

    //NORDESTE
    '82', //
    '71', // BH
    '73', // BH
    '74', // BH
    '75', // BH
    '77', // BH
    '85', //CE
    '88', //CE
    '98', //MA
    '99', //MA
    '83', //PB
    '81', //PE
    '87', //PE
    '86', // PI
    '89', // PI
    '84', // RN
    '79', // SE

    //NORTE
    '68', //AC
    '96', //AP
    '92', //AM
    '97', //AM
    '91', //PA
    '93', //PA
    '94', //PA
    '69', //RO
    '95', //RR
    '63', //TO

    //SUDESTE
    '27', //ES
    '28', //ES
    '31', //MG
    '32', //MG
    '33', //MG
    '34', //MG
    '35', //MG
    '37', //MG
    '38', //MG
    '21', //RJ
    '22', //RJ
    '24', //RJ
    '11', //SP
    '12', //SP
    '13', //SP
    '14', //SP
    '15', //SP
    '16', //SP
    '17', //SP
    '18', //SP
    '19', //SP

    //SUL
    '41', //PR
    '42', //PR
    '43', //PR
    '44', //PR
    '45', //PR
    '46', //PR
    '51', //RS
    '53', //RS
    '54', //RS
    '55', //RS
    '47', //SC
    '48', //SC
    '49', //SC
  ]

  if (!allDDDBrazil.includes(phoneDDD)) return false

  return true
}

export const testPhoneNumber = (phone) => {
  const phoneWithoutMask =  removeMaskPhone(phone)

  const phoneWhithoutDDD = phoneWithoutMask.slice(4)
  if (phoneWhithoutDDD === '999999999') return false
  if (phoneWhithoutDDD === '888888888') return false
  if (phoneWhithoutDDD === '777777777') return false
  if (phoneWhithoutDDD === '666666666') return false
  if (phoneWhithoutDDD === '555555555') return false
  if (phoneWhithoutDDD === '444444444') return false
  if (phoneWhithoutDDD === '333333333') return false
  if (phoneWhithoutDDD === '222222222') return false
  if (phoneWhithoutDDD === '111111111') return false
  if (phoneWhithoutDDD === '000000000') return false

  return true
}

